export class VehicleEngineDto {

  public id!: string;
  public name!: string;
  public sort!: number;

  constructor(init?: Partial<VehicleEngineDto> | undefined) {
    Object.assign(this, init);
  }
}
